export const USER_ROLE = {
  SUPER_ADMIN: 'SA',
  GENERAL_ADMIN: 'GA',
  USER: 'USER',
};
